// @mui
import Container from '@mui/material/Container';
// hooks
// _mock
// components
import { useSettingsContext } from 'src/components/settings';
import MarketigListTable from './list-table';
// assets
//

// ----------------------------------------------------------------------

export default function MarketingList() {
    // const { user } = useMockedUser();
    const settings = useSettingsContext();
    return (
        <Container maxWidth={ settings.themeStretch ? false : 'xl' }>
            <MarketigListTable />
        </Container >
    );
}
